// MUI
import { Button, Checkbox, FormControlLabel, Typography } from '@mui/material';

// Third party
import { Link } from 'react-router-dom';

// Hooks
import { useBoolean } from '../../../../hooks';

// Components
import { TRegisterActionButtons } from '../types';
import { AgreementDialog } from './AgreementDialog';

const RegisterActionButtons = ({ isEulaAgreed, registerLoading, isSubmitting, submitAttempted }: TRegisterActionButtons) => {
  const isEulaOpen = useBoolean();
  const showError = submitAttempted.value && !isEulaAgreed.value;

  return (
    <>
      <FormControlLabel
        control={
          <Checkbox
            checked={isEulaAgreed.value}
            onChange={isEulaAgreed.onToggle}
            sx={{
              color: showError ? 'red' : '#1DB0BF',
              '& .MuiSvgIcon-root': { color: showError ? 'red' : '#1DB0BF' },
              '&.Mui-checked': { color: '#1DB0BF' },
            }}
          />
        }
        label={
          <Typography sx={{ color: '#868B8F', mt: .2 }}>
            I agree to the{' '}
            <Link
              to="#"
              style={{ color: '#ffffff', textDecoration: 'underline' }}
              onClick={isEulaOpen.onTrue}
            >
              EULA
            </Link>
          </Typography>
        }
      />

      <Button
        loading={registerLoading || isSubmitting}
        type="submit"
        fullWidth
        variant="contained"
        disabled={isSubmitting}
        sx={{
          backgroundColor: '#1DB0BF',
          color: '#FFFFFF',
          '&:hover': { backgroundColor: '#1D6F78' },
          width: '100%',
          height: '50px',
          textAlign: 'center',
          display: 'block',
          margin: '0 auto',
          fontWeight: 'bold',
          mt: 2
        }}
      >
        Sign Up
      </Button>
      <Typography
        variant="body2"
        align="center"
        sx={{ color: '#fff', marginTop: 2, mb: { xs: 5, md: 0 } }}
      >
        Already have an account?{' '}
        <Link id="login-link" to="/login" style={{ textDecoration: 'none', color: '#1DB0BF' }}>
          Sign in
        </Link>
      </Typography>

      <AgreementDialog isEulaOpen={isEulaOpen} />
    </>
  );
};

export { RegisterActionButtons };